import { isNull } from 'lodash';
import Dealer from 'models/dealerManagement/dealer/Model.Dealer';
import Model from 'models/Model';
import Product from 'models/productManagement/product/Model.Product';
import Subfee from 'models/productManagement/subfee/Model.Subfee';
import Contract from '../contract/Model.Contract';
import ContractConsentAudit from '../contractConsentAudit/Model.ContractConsentAudit';
import ContractConsentEnhancement from '../contractConsentEnhancement/Model.ContractConsentEnhancement';
import contractConsentFindApi from './find/Api.ContractConsent.Find';
import contractConsentFindPublicApi from './findPublic/Api.ContractConsent.FindPublic';
import getContractConsentDocumentsPublicApi from './getDocumentsPublic/Api.ContractConsent.GetDocumentsPublic';
import contractConsentListApi from './list/Api.ContractConsent.List';

export default class ContractConsent
  extends Model<Model.IContractConsent>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IContractConsent>
{
  id: number;
  type: Model.Enum.ContractConsentRequestType;
  createdAtUtc: string;
  modifiedAtUtc: string;
  contract: Contract;
  productId: number;
  product: Product;
  dealerId: number;
  dealer: Dealer;
  salePriceCAD: number;
  dealerCost: number;
  insurancePremiumCAD: number;
  administrationFeeCAD: number;
  term: number;
  aggregateDescription: string;
  limitOfLiability: string;
  programName: string;
  customerName: string;
  customerPhoneNumber: string;
  customerEmail: string;
  coverage: string;
  dealership: string;
  vehicleVin?: string;
  vehicleEngineType?: string;
  answeredAt?: string;
  isAccepted?: boolean;
  acceptedByUserId?: number;
  acceptedByUserFullName?: string;
  reasonForManualAcceptance?: string;
  noteForManualAcceptance?: string;
  pricePointId?: number;
  subfees?: Subfee[];
  contractConsentEnhancements?: ContractConsentEnhancement[];
  contractConsentAudits?: ContractConsentAudit[];

  constructor(
    data: Partial<Model.IContractConsent> | Utils.FormData<Model.IContractConsent>,
    language?: Locale.Languages
  ) {
    super(
      {
        contract: Contract,
        product: Product,
        dealer: Dealer,
        subfees: [Subfee],
        contractConsentEnhancements: [ContractConsentEnhancement],
        contractConsentAudits: [ContractConsentAudit],
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: `${this?.contract.appNumber}` || this.id.toString(),
      subtitle: `Consent: ${
        isNull(this.isAccepted) ? 'Waiting for consent' : this.isAccepted ? 'Consent Given' : 'Consent Rejected'
      }`,
    };
  }
  static async list(body?: Api.Core.ContractConsent.List.IRequest) {
    const { payload, ...rest } = await contractConsentListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ContractConsent(it)),
        count: payload.count,
      },
    };
  }
  static async find(params: { id: number }) {
    const { payload, ...rest } = await contractConsentFindApi(params);
    return {
      ...rest,
      payload: new ContractConsent(payload),
    };
  }
  static async findPublic({
    params,
    access_token,
  }: {
    params: Api.Core.ContractConsent.FindPublic.IParams;
    access_token: string;
  }) {
    const { payload, ...rest } = await contractConsentFindPublicApi({ params, access_token });
    return {
      ...rest,
      payload: new ContractConsent(payload),
    };
  }
  static async getDocumentsPublic({
    params,
    access_token,
  }: {
    params: Api.Core.ContractConsent.GetDocumentsPublic.IParams;
    access_token: string;
  }) {
    return await getContractConsentDocumentsPublicApi({ params, access_token });
  }
}
